import convertFormData from '@module/utils/convertFormData';

import { fetchExtended } from '../../../utils/fetch/client-fetch';
import type { ApiBaseResponse } from '../../type';
import type {
  AddBlockParams,
  AddBlockResponse,
  BlockListParams,
  BlockWordListParams,
  BlockWordListResponse,
  CancelBlockParams,
  FetchBlockListResponse,
} from './type';

export const fetchBlockList = async (blockListParams: BlockListParams) => {
  const res = await fetchExtended('/v1/block/index', {
    method: 'POST',
    credentials: 'include',
    body: convertFormData(blockListParams),
  });

  const result = await res.json();

  return result as FetchBlockListResponse;
};

export const fetchCancelBlock = async (cancelBlockParams: CancelBlockParams) => {
  const res = await fetchExtended('/v1/block/cancel', {
    method: 'POST',
    credentials: 'include',
    body: convertFormData(cancelBlockParams),
  });

  const result = await res.json();

  return result as ApiBaseResponse;
};

export const addBlock = async (addBlockParams: AddBlockParams) => {
  const res = await fetchExtended('/v1/block/add', {
    method: 'POST',
    credentials: 'include',
    body: convertFormData(addBlockParams),
  });

  const result = await res.json();

  return result as AddBlockResponse;
};

export const fetchBlockWordList = async (blockWordListParams: BlockWordListParams) => {
  const res = await fetchExtended('/v1/block/word_list', {
    method: 'POST',
    credentials: 'include',
    body: convertFormData(blockWordListParams),
  });

  const result = await res.json();

  return result as BlockWordListResponse;
};
